module.exports = __webpack_public_path__ + "static/media/pop-sessions.cd974997.jpg";